import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
`;
export const SectionDescription = styled.div `
  strong {
    font-weight: var(--font-weight-medium);
  }
`;
export const PerksContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-100);

  margin-top: 16px;
  margin-bottom: 16px;
`;
export const ButtonsContainer = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-300);
`;
export const BannerContainer = styled.div `
  margin-bottom: var(--space-400);
`;
export const SubscriptionContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: var(--space-150);
`;
export const SubscriptionName = styled.div `
  font-weight: var(--font-weight-medium);
`;
export const SubscriptionDescription = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-100);
`;
